import React, { useState } from 'react';

const ImageMessage = ({ src, onOpen }) => {
   const [failed, setFailed] = useState(false);
   if (!src) return null;
   if (failed) return <div className='chatterbox-media-error'>Media could not be loaded.</div>;

   return (
      <button className='chatterbox-image-button' type='button' onClick={() => onOpen(src)}>
         <img src={src} alt='Message attachment' onError={() => setFailed(true)} />
      </button>
   );
};

export default ImageMessage;
